import * as React from 'react';
import { Responsive, ArticleHeading3 } from '@cian/ui-kit';

import * as styles from './PageTitle.css';

export const PageTitle: React.FC<React.PropsWithChildren<{}>> = props => {
  const { children } = props;

  return (
    <>
      <Responsive desktop tablet>
        <h1 className={styles['desktop-heading']}>{children}</h1>
      </Responsive>
      <Responsive phone>
        <ArticleHeading3 as="h1">{children}</ArticleHeading3>
      </Responsive>
    </>
  );
};
